// extracted by mini-css-extract-plugin
export default {"varriant2":"InputVariant2_varriant2__rD8hQ","varriant1_input2":"InputVariant2_varriant1_input2__5muUF","varriant1_icon":"InputVariant2_varriant1_icon__6nivh"};